import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/useI18n";

export default function LangSwitcher() {
  const { lang, enPath, esPath } = useI18n();
  return (
    <div className="flex items-center gap-0.5 rounded-lg border border-border p-0.5 text-xs font-medium" data-testid="lang-switcher">
      <Link to={enPath} data-testid="lang-en" className={`px-2 py-1 rounded-md transition-colors ${lang === "en" ? "bg-primary text-white" : "text-muted-foreground hover:text-foreground"}`}>EN</Link>
      <Link to={esPath} data-testid="lang-es" className={`px-2 py-1 rounded-md transition-colors ${lang === "es" ? "bg-primary text-white" : "text-muted-foreground hover:text-foreground"}`}>ES</Link>
    </div>
  );
}
